import { User } from '@deltek/specification-client/core/Models/user'

export interface UserStateType extends User {
    fullName: string
    profileInfo: Record<string, string>
    professionalDiscipline: string
    professionalRole: string
    title: string
    imageUrl: string
}

export enum NoteType {
    GeneralNote = 'GENERALNOTE',
    DeleteOrStatusChange = 'DELETEORSTATUSCHANGE',
    ListingTypeChange = 'LISTINGTYPECHANGE',
    CopyMove = 'COPYMOVE',
}

export type NoteTypeReasonOption = {
    noteType: NoteType
    reason: string
}

export type ProductDetailNoteData = {
    id: string
    listingId: string
    longDescription: string
    noteType: NoteType
    reason: string
    seenByUserId: string[]
    createdDate: string
    userName: string
    userRole: string
    userFullName: string
    userId: string
    isTemporary?: boolean
}

export type PDNStoreType = {
    listingId: string
    tempNotes: Record<string, Partial<ProductDetailNoteData>>
    count: number
    notes: Record<string, Partial<ProductDetailNoteData>>
    currentUser: Partial<UserStateType>
    noteTypes: NoteType[]
    isLoaded?: boolean
}

export type PDNResponseType = {
    id: string
    listingId: string
    content: string
    reason: string
    productDetailNoteType: string
    seenByUserId: string[]
    metadata: Record<string, any>
}
